import React, { CSSProperties, useEffect } from 'react';
import cn from 'classnames';

import { appInsights } from '@/services/Telemetry/AppInsights.service';
import { EnvUtils } from '@/utils/env.utils';
import { getSubscriptionId } from '@/utils/auth/subscription.utils';
import styles from './page.module.scss';

interface IPageProps {
  children: any;
  padding?: boolean;
  style?: CSSProperties;
  pageTitle: string;
  className?: string;
  withBreadcrumbsOffset?: boolean;
  // TODO: remove after redesign
  withWhiteBackground?: boolean;
}

export default function Page({
  children,
  padding = false,
  style,
  pageTitle,
  className,
  withWhiteBackground = false,
  withBreadcrumbsOffset = true,
}: IPageProps) {

  const trackPageVisit = async () => {
    if (EnvUtils.isProduction()) {
      appInsights.trackPageView({
        name: pageTitle,
        pageType: 'page',
        properties: {
          subscriptionid: await getSubscriptionId(),
          pageUrl: window.location.href
        }
      });
    }
  };

  useEffect(() => {
    document.title = pageTitle;
    trackPageVisit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageTitle]);

  return (
    <div
      style={style}
      className={cn(
        styles.page,
        {
          [styles.padding]: padding,
          [styles.white]: withWhiteBackground,
          [styles['breadcrumbs-offset']]: withBreadcrumbsOffset
        },
        className
      )}
    >
      {children}
    </div>
  );
}
